import { directionalCoverBetween, type ShapeCoverVolume, type ShapePoint3d } from '../../../../ft3d/engine/ft3d-shape-core.js';
import { sightSegmentHit3d } from '../../../../ft3d/engine/ft3d-sight-core.js';

/** Eye band above the held feet, including a roof support. Lying bodies use their drawn band. */
export function abilityRaySource(body: ShapeCoverVolume): ShapePoint3d {
  return { x: body.x, y: body.y, z: body.zMin + (body.zMax - body.zMin) * .8 };
}

/** Use the native nine-sample classifier and the shared physical floor/roof/stair ray.
 * A support below either endpoint never intersects the segment; a roof crossed on the way does. */
export function abilityCoverBetween(shape: unknown, source: ShapePoint3d, target: ShapeCoverVolume,
  occluders: ShapeCoverVolume[] = [], options: Parameters<typeof directionalCoverBetween>[4] = {}) {
  return directionalCoverBetween(shape, source, target, [...occluders, {
    kind: 'circle', x: 0, y: 0, r: 0, zMin: 0, zMax: 0,
    intersectsSegment: (from, to) => sightSegmentHit3d(shape, from, to) !== null,
  }], options);
}
